import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { ModalDetalhesRedeCredenciadaComponent } from '../../modals/modal-detalhes-rede-credenciada/modal-detalhes-rede-credenciada.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { faCircleInfo, faLocationDot, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
@Component({
  selector: 'lista-redecredenciada',
  templateUrl: './lista-redecredenciada.component.html',
  styleUrls: ['./lista-redecredenciada.component.css']
})
export class ListaRedecredenciadaComponent {
  @Input() itens!: number;
  @Output() changePagination: EventEmitter<number> = new EventEmitter();
  //Var
  lista: any;
  isMobile: boolean = false;
  isTablet: boolean = false;
  //Icones
  faTriangleExclamation = faTriangleExclamation;
  faCircleInfo = faCircleInfo;
  faLocationDot = faLocationDot;
  visibleIndexes: number[] = [];
  constructor(private modalService: NgbModal) { }
  detalheEntidade(credenciado: any) {
    const modalRef = this.modalService.open(ModalDetalhesRedeCredenciadaComponent, { size: 'lg', centered: true });
    modalRef.componentInstance.corpoClinico = credenciado;
  }
  google(a: any, b: any, c: any, d: any, e: any) {
    let link = 'https://www.google.com.br/maps/search/RUA' + a + ',' + b + ',' + c + ',' + d + ',' + e;
    window.open(link, '_blank')
  }
  onChangePagination(page: number) {
    this.changePagination.emit(page);
  }
  ngOnChanges(changes: SimpleChanges) {
    this.lista = this.itens;
  }
}
